<template>
  <transition name="fade">
    <section v-if="alert.status != null" class="alert" :class="{'success': alert.status === 'success', 'error': alert.status === 'error'}">
      <div class="container">
        <div class="left">
          <p>{{ alert.message }}</p>
        </div>
        <div class="right">
          <v-icon name="times" @click="close()" class="close"></v-icon>
        </div>
      </div>
    </section>
  </transition>
</template>
<style lang="scss" scoped>
  .alert {
    position: fixed;
    bottom: 20px;
    width: 40%;
    right: 30%;
    border-radius: 10px;

    @media (max-width: 1024px) {
      width: 90%;
      right: 5%;
    }

    .container {
      width: 90%;
      display: flex;
      justify-content: space-evenly;

      p {
        margin: 0;
        padding: 0;
        margin-top: 10px;
      }

      .close {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
      }
    }

    &.success {
      color: #155724;
      background-color: #d4edda;
      border-color: #c3e6cb;
    }

    &.error {
      color: #721c24;
      background-color: #f8d7da;
      border-color: #f5c6cb;
    }
  }
</style>
<script>
export default {
  data() {
    return {
      alert: {
        status: null,
        message: null,
      },
    };
  },

  created() {
    this.bus.$on('alert', (alert) => {
      this.alert = alert;

      setTimeout(() => {
        this.close();
      }, 6000);
    });
  },

  methods: {
    close() {
      this.alert = {
        status: null,
        message: null,
      };
    },
  },
};
</script>
